<div class="card-group">
  <div class="card">
    <div class="card-body">
      <p class="card-text text-success mb-3">
        <lucide-icon [img]="icons.checkmark"></lucide-icon> Une activité sera acceptée si:
      </p>
      <ul>
        <li>Il s'agit d'une activité de loisir: sportive, culturelle, créative, etc.</li>
        <li>Elle est collective (accepte au moins 2 participants)</li>
        <li>Elle est présentielle</li>
        <li>Elle est apolitique</li>
        <li>Elle est laïque</li>
      </ul>
      <p class="card-text">
        L'activité peut être ponctuelle (camps) ou régulière (entraînement hebdomadaire), gratuite ou payante.
      </p>
    </div>
  </div>
  <div class="card">
    <div class="card-body">
      <p class="card-text text-danger mb-3">
        <lucide-icon [img]="icons.ban"></lucide-icon> Ces activités seront en principe refusées:
      </p>
      <ul>
        <li>Les activités qui ne sont pas en lien avec les loisirs</li>
        <li>Les événements qui n'acceptent que des visiteurs (match professionnel de football, représentation théâtrale professionnelle, etc.) </li>
        <li>Les cours privés</li>
        <li>Les activités liées à des partis politiques</li>
        <li>Les activités à caractère religieux</li>
      </ul>
    </div>
  </div>
</div>
